import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const validateToken = async (admintoken) => {
  try {
    const response = await axios.get(`${API_URL}/validate-token`, {
      headers: {
        Authorization: `Bearer ${admintoken}`,
      },
    });

    if (response.status === 200) {
      // If token is valid, return true
      return true;
    }
  } catch (err) {
    console.error('Token validation failed:', err);
    // In case of error (invalid token), return false
    // localStorage.removeItem('adminToken');
  }
  return false; // Token is invalid or expired
};


export const createContact = async (contactData) => {
  try {
    const response = await axios.post(`${API_URL}/contcs`, contactData);
    return response.data;
  } catch (error) {
    console.error('Error creating contact:', error);

    if (error.response) {
      if (error.response.status === 409) {
        throw new Error('Email already exists.'); // Throw a custom error message
      }
      throw new Error(error.response.data.message || 'An error occurred while creating the contact.');
    } else if (error.request) {
      throw new Error('No response from server. Please try again later.');
    } else {
      throw new Error('An error occurred while creating the contact. Please try again.');
    }
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await axios.post(`${API_URL}/forgot-password`, { user_name: email }); // Adjust API endpoint as necessary
    // //console.log("response forgot password", response.data)
    return response.data;
  } catch (error) {
    console.error(error.message)
    throw error.response.data;
  }
};
export const updateAsmtStatus = async (assessmentId, userId) => {
  try {
    const response = await axios.post(`${API_URL}/update-status`, {
      assessmentId,
      userId
    });
    return response.data;
  } catch (error) {
    console.error('Error updating assessment status:', error);
    throw error;
  }
}


export const getComponentById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/components/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching component data:', error);
    throw error;  // Re-throw error for further handling if needed
  }
};

export const getComponentWiseAvgScore = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/components-score/${id}`);
    return response;
  } catch (error) {
    console.error('Error fetching component-wise average score:', error);
    throw error;
  }
};

export const getQuestionFromConfig = async () => {
  try {
    const response = await axios.get(`${API_URL}/asmt-config`);
    return response.data;
  } catch (error) {
    console.error('Error fetching questions from config:', error);
    throw error;
  }
};

export const updateUserDetailsById = async ({ id, data }) => {
  try {
    const response = await axios.put(`${API_URL}/users/${id}`, data);
    console.log("responise", response)
    return response.data;
  } catch (error) {
    console.error('Error updating user details:', error);
    throw error;
  }
};

export const sendReminderEmail = async ({ id }) => {
  ////console.log("iddd", id)
  try {
    const response = await axios.post(
      `${API_URL}/send-reminder/${id}`,
      { id },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    ////console.log('API Response:', response.data); // Log the response to inspect the data
    return response; // Return the response data from the API
  } catch (error) {
    console.error('Error sending reminder email:', error.response || error.message);
    throw error; // Rethrow the error for further handling if needed
  }
};


export const updateAsmtUsrById = async (id, userId, updateData) => {
  try {
    const response = await axios.put(`${API_URL}/ass_users/${id}/${userId}`, updateData);
    return response.data;
  } catch (error) {
    console.error("Error updating assessment user:", error);
    throw error;
  }
}

export const updateAsmtById = async (id, updateData) => {
  try {
    const response = await axios.put(`${API_URL}/asmt/${id}`, updateData);
    return response.data;
  } catch (error) {
    console.error("Error updating assessment:", error);
    throw error;
  }
};


export const getAsmtById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/asmt/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching assessment by ID:", error);
    throw error;
  }
};


export const getUserByUserId = async (userId) => {
  try {
    const response = await axios.get(`${API_URL}/users/${userId}`);
    return response.data; // Return the user data
  } catch (error) {
    console.error(`Error fetching user with ID ${userId}:`, error);
    throw error; // Rethrow the error for further handling if needed
  }
};




export const getAllParticipantsOfAssessment = async (assessmentId) => {
  try {
    const response = await axios.get(`${API_URL}/ass_users/${assessmentId}`);
    ////console.log("Response:", response.data); // Log the response data for debugging
    return response;
  } catch (error) {
    console.error("Error fetching participants:", error);
    throw new Error("Failed to fetch participants. Please try again later."); // Throw an error for further handling
  }
};

export const getParticipantResponse = async (assessment_user_id) => {
  try {
    const response = await axios.post(`${API_URL}/participant-status`, { assessment_user_id: assessment_user_id });
    // ////console.log('Submission successful:', response.data);
    const result = response.data.response[0]

    return result ? true : false;
  } catch (error) {
    console.error('Error during submission:', error.message);
    throw error;
  }
};



export const createUserAns = async (answersData) => {
  ////console.log("answer", answersData);
  try {
    const response = await axios.post(`${API_URL}/ass_user_ans`, answersData);
    // //console.log('Submission successful:', response.data);
  } catch (error) {
    console.error('Error during submission:', error.message);

    // setErrorMessage('Submission failed. Please try again.');
  }
}

// export const UpdateUserAns = async (answersData) => {
//   ////console.log("answer", answersData);
//   try {
//     const response = await axios.put(`${API_URL}/ass_user_ans`, answersData);
//     ////console.log('Submission successful:', response.data);
//   } catch (error) {
//     console.error('Error during submission:', error.message);

//     // setErrorMessage('Submission failed. Please try again.');
//   }
// }

export const createParticipants = async (participants, source_user_id, assessment_id, invitation_note) => {
  const token = localStorage.getItem('authToken');
  try {

    ////console.log(participants)
    const response = await axios.post(
      `${API_URL}/participants`,
      { participants, source_user_id, assessment_id, invitation_note },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    // //console.log('Participants submitted:', response.data);
    return response;
  } catch (err) {
    if (err.response) {
      console.error(err.response || "Server error");
      throw new Error(err.response.data.message || "An error occurred");
    } else {
      console.error("An unexpected error occurred:", err);
      throw new Error("An unexpected error occurred");
    }
  }
};


export const newAssessment = async (type, source_user_id) => {

  ////console.log("new asmt", type, source_user_id)
  try {
    const token = localStorage.getItem('authToken');
    const response = await axios.post(
      `${API_URL}/asmt`,
      { association_type: type, source_user_id },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    const { id } = response.data;
    ////console.log("assessment id", id);
    return id; // Return the id as normal
  } catch (error) {
    // Throw an error if an issue is encountered
    if (error.response) {
      console.error('Response error:', error.response.data.message);
      throw new Error(error.response.data.message || 'Server error occurred');
    } else if (error.request) {
      console.error('No response received from the server:', error.request);
      throw new Error('No response received from the server');
    } else {
      console.error('Error:', error.message);
      throw new Error(error.message || 'An unknown error occurred');
    }
  }
};

//what I can do generate user-token as per click by admin and fetchLogged in user
//make sure only admin can do this request

export const fetchLoggedInUser = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/users/me`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const users = response.data;
    return users;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};



// Fetch all assessments initiated by the user

export const fetchUserAllAssessments = async (id) => {

  const token = localStorage.getItem('authToken');
  try {
    const response = await axios.get(`${API_URL}/usrasmts/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("317", token);
    const allAssessment = response.data;
    return allAssessment;
  } catch (err) {
    if (err.response) {
      // Check if the response contains a message
      console.error(err.response.data.message || "Server error");
      throw new Error(err.response.data.message || "An error occurred");
    } else {
      console.error("An unexpected error occurred:", err);
      throw new Error("An unexpected error occurred");
    }
  }
};


//for default user
// export const login = async (credentials) => {
//   try {
//     // Clear previous auth tokens
//     localStorage.removeItem('authToken');
//     localStorage.removeItem('user');

//     // Simulate server response with a fake token and user data
//     const fakeResponse = {
//       token: 'fakeToken123456', // This can be any random string for testing
//       user: {
//         id: 1,
//         name: 'Test User',
//         email: credentials.user_name,
//         role: 'admin' // You can customize this as needed
//       }
//     };

//     // Store fake token and user in localStorage
//     localStorage.setItem('authToken', fakeResponse.token);
//     localStorage.setItem('user', JSON.stringify(fakeResponse.user));

//     // Return the fake token and user
//     return fakeResponse;
//   } catch (error) {
//     console.error('Login error:', error.message);
//     throw new Error('Failed to login.');
//   }
// };

export const logout = () => {
  if (localStorage.getItem("adminToken")) {
    localStorage.removeItem('adminUsrtoken');
  }
  else {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  }

};


export const signup = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/usr-signup`, userData);
    return response;
  } catch (err) {

    if (err.response) {
      throw new Error(err.response.data.message);
    }
    throw new Error(err.message || 'Signup failed');
  }
};


export const login = async (credentials) => {
  try {
    // Check for internet connection
    // //console.log("credentials", )
    if (!navigator.onLine) {
      throw new Error('No internet connection. Please check your connection and try again.');
    }

    // Clear previous authentication data
    localStorage.removeItem('authToken');
    // localStorage.removeItem('user');

    // Make the login request
    const response = await axios.post(`${API_URL}/usr-login`, credentials);
    const { token } = response.data;

    // Save token to local storage
    localStorage.setItem('authToken', token);
    // localStorage.setItem('user', JSON.stringify(user));

    return { token };
  } catch (error) {
    if (error.message === 'No internet connection. Please check your connection and try again.') {
      console.error('No internet connection');
      throw new Error(error.message);
    } else if (error.response) {
      console.error('Login error:', error.response.data.message);
      throw new Error(error.response.data.message);
    } else if (error.request) {
      console.error('No response received:', error.request);
      throw new Error('No response received from the server');
    } else {
      console.error('Error', error.message);
      throw new Error(error.message);
    }
  }
};